import React, { useState, FormEvent } from 'react';
import { motion } from 'framer-motion';
import './ChatInput.css';

interface ChatInputProps {
  onSendMessage: (message: string) => void;
  disabled?: boolean;
  onOpenCamera?: () => void;
  cameraRequested?: boolean;
  cameraDisabled?: boolean;
  value?: string;
  onChangeValue?: (value: string) => void;
}

const ChatInput: React.FC<ChatInputProps> = ({
  onSendMessage,
  disabled = false,
  onOpenCamera,
  cameraRequested = false,
  cameraDisabled = false,
  value,
  onChangeValue,
}) => {
  const [message, setMessage] = useState('');

  const isControlled = value !== undefined;
  const currentValue = isControlled ? value ?? '' : message;

  const updateValue = (next: string) => {
    if (onChangeValue) {
      onChangeValue(next);
    }
    if (!isControlled) {
      setMessage(next);
    }
  };
  
  // 提交表单
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    
    if (currentValue.trim() && !disabled) {
      onSendMessage(currentValue);
      updateValue('');
    }
  };
  
  // 处理键盘事件，支持Shift+Enter换行，Enter发送
  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      handleSubmit(e);
    }
  };
  
  return (
    <motion.form
      className="chat-input-form"
      onSubmit={handleSubmit}
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="input-container">
        <textarea
          className="message-input"
          placeholder="请输入您的问题..."
          value={currentValue}
          onChange={(e) => updateValue(e.target.value)}
          onKeyDown={handleKeyDown}
          disabled={disabled}
        />
        {onOpenCamera && (
          <button
            type="button"
            className={`camera-trigger-button ${cameraRequested ? 'highlight' : ''}`}
            onClick={onOpenCamera}
            disabled={disabled || cameraDisabled}
            title={cameraDisabled ? '图像上传不可用或已拒绝权限' : '打开图像上传工具'}
          >
            <span className="camera-trigger-icon">🖼️</span>
            <span>{cameraRequested ? '前往上传' : '图像上传'}</span>
          </button>
        )}
        <button
          type="submit"
          className="send-button"
          disabled={!currentValue.trim() || disabled}
        >
          发送
        </button>
      </div>
      <div className="input-help-text">
        按 Enter 发送，Shift + Enter 换行
      </div>
    </motion.form>
  );
};

export default ChatInput; 